import React from "react"

import { StaticQuery, graphql } from "gatsby"
import projectsStyle from "./projects.module.scss"


export default function Projects() {
  return (
    <StaticQuery
      query={graphql`
        query {
          allContentfulProject(sort: { fields: Date, order: DESC }) {
            edges {
              node {
                title
                url
                organization
                body {
                  body
                }
                Date(formatString: "MMMM, YYYY")
                image {
                  fixed {
                    width
                    height
                  }
                  file {
                    url
                  }
                }
                stacks
              }
            }
          }
        }
      `}
      render={data => (
        <div>
          <div id="projects">
            <div>
              <h2 className={projectsStyle.title}>RECENT PROJECTS</h2>
              <ol className={projectsStyle.projects}>
                {data.allContentfulProject.edges.map(edge => {
                  return (
                    <div className={projectsStyle.projectBlockWrapper}>
                      <section className={projectsStyle.projectWrapper}>
                        <li>
                          <div className={projectsStyle.projectContent}>
                            <div className={projectsStyle.container}>
                              <div className={projectsStyle.left}>
                                <h2 className={projectsStyle.projectName}>
                                  {edge.node.title}
                                </h2>
                                <p className={projectsStyle.body}>
                                  {edge.node.body.body}
                                </p>
                                <div className={projectsStyle.stacksWrapper}>
                                  <h5>DEVELOPMENT TOOLS</h5>
                                  <ol className={projectsStyle.stacks}>
                                    {edge.node.stacks.map(stack => {
                                      return (
                                        <li className={projectsStyle.li}>
                                          {stack}
                                        </li>
                                      )
                                    })}
                                  </ol>
                                </div>

                                <div className={projectsStyle.buttonWrapper}>
                                  <a
                                    className={projectsStyle.button}
                                    href={edge.node.url}
                                    target="_blank"
                                  >
                                    View Project
                                  </a>
                                </div>
                              </div>
                              <div className={projectsStyle.right}>
                                <div className={projectsStyle.contents}>
                                  {/* <Img
                                  fixed={edge.node.image.fixed}
                                  alt={edge.node.title}
                                  src={edge.node.image.file.url}
                                /> */}
                                  <img
                                    className={projectsStyle.img}
                                    src={edge.node.image.file.url}
                                    alt={edge.node.title}
                                  ></img>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </section>
                    </div>
                  )
                })}
              </ol>
            </div>
          </div>
        </div>
      )}
    />
  )
}
